// Who the current scene already shows in a layer of their own, so a Dynamic grid can leave them out rather than
// draw them twice. Fed each time the scene's layers change; the grid mounters subscribe through
// callContext.onSceneClaims. Only visible layers count. A speaker layer claims what it points at: a person, or - with
// a deviceId - just that screen share or extra camera, not the person themselves.
export function createSceneClaims() {
	const listeners = new Set();
	let claims = { callerIds: new Set(), streamIds: new Set(), camera: false };
	return {
		update(layers) {
			const callerIds = new Set();
			const streamIds = new Set();
			let camera = false;
			for(const l of layers || []) {
				if(!l.visible || l.type !== 'widget') continue;
				const widgetType = l.props?.widgetType;
				if(widgetType === 'camera') camera = true;
				else if(widgetType === 'speaker' && l.props.settings?.callerId) {
					if(l.props.settings.deviceId) streamIds.add(l.props.settings.deviceId);
					else callerIds.add(l.props.settings.callerId);
				}
			}
			claims = { callerIds, streamIds, camera };
			for(const cb of listeners) cb(claims);
		},
		subscribe(cb) {
			listeners.add(cb);
			cb(claims);
			return () => listeners.delete(cb);
		},
	};
}
